import { GlobalStyle } from "components/GlobalStyle";
import { Router } from "components";

function App() {
  return (
    <>
      <GlobalStyle />
      <Router />
    </>
  );
}

export default App;
